import { useEffect, useState } from "react";
import { GET_PROPERTY_CATEGORIES } from "../api/constants";

const useCategories = () => {
  const [categories, setCategories] = useState([]);
  

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(GET_PROPERTY_CATEGORIES);
        const data = await response.json();

        // ✅ tolerate different API shapes
        if (Array.isArray(data?.data)) {
          setCategories(data.data);
        } else if (Array.isArray(data)) {
          setCategories(data);
        } else {
          setCategories([]);
        }
      } catch (err) {
        console.error("Error fetching categories:");
      } 
    };

    fetchCategories();
  }, []);

  return { categories };
};


export default useCategories;
